import { useMantineTheme } from '@mantine/core';
import capitalize from 'lodash.capitalize';
import type { JSX } from 'react';
import React from 'react';

import { EFormState } from '@feathr/blackbox';
import { Pill } from '@feathr/components';

interface IProps {
  status: EFormState;
}

function StatusPill({ status }: Readonly<IProps>): JSX.Element {
  const {
    colors: {
      sky: { 6: published },
      slate: { 6: draft },
      violet: { 5: archived },
    },
  } = useMantineTheme();

  const map = {
    [EFormState.Published]: published,
    [EFormState.Draft]: draft,
    [EFormState.Archived]: archived,
  };

  return (
    <Pill theme={map[status]} variant={'secondary'}>
      {capitalize(status)}
    </Pill>
  );
}

export default StatusPill;
